import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "../queryKeys";

export const useAddInquiryLocationMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (locationId: number) => {
      const locationIds = localStorage.getItem("inquiryLocations");
      const ids = JSON.parse(locationIds ?? "[]");
      localStorage.setItem(
        "inquiryLocations",
        JSON.stringify([...ids, locationId])
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.INQUIRY_LOCATIONS],
      });
    },
  });
};

export const useRemoveInquiryLocationMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (locationId: number) => {
      const locationIds = localStorage.getItem("inquiryLocations");
      if (!locationIds) return;

      const ids = JSON.parse(locationIds);
      const newIds = ids.filter((id: number) => id !== locationId);

      localStorage.setItem("inquiryLocations", JSON.stringify(newIds));
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.INQUIRY_LOCATIONS],
      });
    },
  });
};

export const useClearInquiryLocationsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      localStorage.removeItem("inquiryLocations");
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.INQUIRY_LOCATIONS],
      });
    },
  });
};

export const useSetInquiryLocationMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (locationId: number) => {
      localStorage.setItem("inquiryLocations", JSON.stringify([locationId]));
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.INQUIRY_LOCATIONS],
      });
    },
  });
};
